var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadioUnchecked = function SvgRadioUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#a8a8a8",
    d: "M2.5 12c0-5.244 4.256-9.5 9.5-9.5s9.5 4.256 9.5 9.5-4.256 9.5-9.5 9.5-9.5-4.256-9.5-9.5z"
  })));
};
export default SvgRadioUnchecked;